const content = {
  title: "Conditionals (All Types & Mixed Conditionals)",
  explanation: `
At B2 level, conditionals express logic, probability, hypothesis, and retrospective evaluation.
Example: If demand increases, prices rise.

Different conditional types map to different realities: factual, likely, hypothetical, and impossible past.
Example: If it rains, we will cancel the event.

Third and mixed conditionals are especially useful for discussing regret and alternative outcomes.
Example: If I had left earlier, I would not be stuck in traffic now.

Mastering conditionals improves argument quality because it clarifies cause, consequence, and degree of certainty.
Example: Unless governments act decisively, long-term costs will escalate.
  `,
  rules: [
    "Zero Conditional: if + present simple, present simple (general truths)",
    "First Conditional: if + present simple, will + base verb (real future result)",
    "Second Conditional: if + past simple, would + base verb (unreal present or future)",
    "Third Conditional: if + past perfect, would have + past participle (unreal past)",
    "Mixed Conditionals link different time frames (past to present, past to future)",
    "Use 'unless' as a stronger form of 'if ... not'"
  ],
  examples: [
    "If you heat ice, it melts. (general truth)",
    "If it rains, I will stay at home. (real future possibility)",
    "If I had more time, I would travel more. (unreal present)",
    "If she had studied harder, she would have passed the exam. (unreal past)",
    "If I had taken that job, I would be living abroad now. (past cause, present result)",
    "Unless you act quickly, the opportunity will be lost."
  ]
};

export default content;


